import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { PositionsByArea } from "@/routes/processes/[processId]/vbs/work-orders/execution/[workOrderId]/treatment/_components/positions-by-area";

export function WorkOrderExecutionTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return <PositionsByArea workOrder={data!} />;
}
